import React from "react";
import { Table, Empty } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

const TaskDirectUserTable = ({ data }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  // ✅ Check if any record has deadline_soft
  const hasDeadlineSoft = data?.some((item) => item.deadline_soft);
  console.log("Deadline Soft Values:", data?.map((d) => d.deadline_soft));

  const columns = [
    {
      title: "Order Id",
      dataIndex: "key",
      key: "key",
      render: (key) => (
        <Link target="_blank" to={`/order-management/my-orders/${key}`}>
          {key}
        </Link>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    // ✅ Conditionally add the column
    ...(hasDeadlineSoft
      ? [
          {
            title: "Deadline Soft",
            dataIndex: "deadline_soft",
            key: "deadline_soft",
            render: (text) =>
              text ? moment(text).format("DD-MM-YYYY hh:mm A") : "N/A",
          },
        ]
      : []),
    {
      title: "Word",
      dataIndex: "word",
      key: "word",
    },
    {
      title: "Order Ownership",
      dataIndex: "ownership",
      key: "ownership",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
      render: (text, record) => (
        <div>
          <div>{record.created_by || "N/A"}</div>
          <div>
            {record.created_at
              ? moment(record.created_at).format("DD-MM-YYYY hh:mm A")
              : "N/A"}
          </div>
        </div>
      ),
    },
  ];

  const transformDataForMobile = (item) => {
    const rows = [
      {
        key: "Order Id",
        value: (
          <Link target="_blank" to={`/order-management/my-orders/${item.key}`}>
            {item.key}
          </Link>
        ),
      },
      { key: "Title", value: item.title },
      ...(hasDeadlineSoft
        ? [
            {
              key: "Deadline Soft",
              value:
                item.deadline_soft &&
                moment(item.deadline_soft).format("DD-MM-YYYY hh:mm A"),
            },
          ]
        : []),
      { key: "Word", value: item.word },
      { key: "Order Visibility", value: item.ownership },
      {
        key: "Created By",
        value: item.created_by || "N/A",
      },
      {
        key: "Created At",
        value: item.created_at
          ? moment(item.created_at).format("DD-MM-YYYY hh:mm A")
          : "N/A",
      },
    ];
    return rows;
  };

  return (
    <div>
      {data && data.length > 0 ? (
        isMobile ? (
          <div style={{ marginTop: "20px" }}>
            {data.map((item, index) => (
              <Table
                key={index}
                columns={[
                  { title: "Key", dataIndex: "key", key: "key" },
                  { title: "Value", dataIndex: "value", key: "value" },
                ]}
                dataSource={transformDataForMobile(item)}
                pagination={false}
                bordered
                size="small"
                showHeader={false}
                style={{ marginBottom: "25px" }}
              />
            ))}
          </div>
        ) : (
          <Table columns={columns} dataSource={data} rowKey="key" pagination={false} />
        )
      ) : (
        <Empty description="No data available" />
      )}
    </div>
  );
};

export default TaskDirectUserTable;
